export default "__VITE_ASSET__BwT0GR0Y__"